import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { defaultEntregaObraClienteCadastroForm, EntregaObraClienteCadastroForm, EntregaObraClienteCadastroSchema } from "../../../schemas/entrega_obra_cliente_lista/entregaObraClienteCadastro";
import { DefaultFormCheckBox } from "../../../../../../common/components/default_form_checkbox";
import { DropDownUnidade } from "../../../../../../common/components/dropdown_unidade";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";

type props = {
    open: boolean,
    saving: boolean,
    loading: boolean,
    idCentroCusto: number,
    nomeCentroCusto?: string,
    ddlChecklistEntregaObra: DropDown[],
    onClose: () => void,
    onSubmit: (form: EntregaObraClienteCadastroForm) => void,
}

export const CadastroVistoriaModal = ({
    open,
    saving,
    loading,
    nomeCentroCusto,
    idCentroCusto,
    ddlChecklistEntregaObra,
    onClose,
    onSubmit,
}: props) => {

    const hookFormCadastro = useForm<EntregaObraClienteCadastroForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: defaultEntregaObraClienteCadastroForm,
        resolver: zodResolver(EntregaObraClienteCadastroSchema),
    });

    const handleClose = () => {
        hookFormCadastro.reset();
        onClose();
    };

    const handleSubmit = (form: EntregaObraClienteCadastroForm) => {
        hookFormCadastro.reset();
        onSubmit(form);
    };

    const [clienteCadastrado] = hookFormCadastro.watch(['clienteCadastrado']);

    return (
        <BaseFormControlledModal
            open={open}
            saving={saving}
            loading={loading}
            width="80rem"
            title="Cadastro Vistoria"
            onClose={handleClose}
            onSubmit={hookFormCadastro.handleSubmit(handleSubmit)}>
            <FormContainer title={"Informações"} arrangement="fullRow">
                <>
                    <div className="w-full flex items-start justify-start gap-2">
                        <label className="font-medium text-gray-700">Centro de Custo: </label>
                        <span className="ms-1 flex items-center border-l-dark-green">
                            {nomeCentroCusto}
                        </span>
                    </div>
                    <div className=" w-[40%] flex items-start justify-between">
                        <label className="font-medium text-gray-700">Vistoria *</label>
                        <span className="ms-1">
                            <DefaultFormCheckBox
                                name='tipoVistoriaCliente'
                                label='Cliente'
                                reactHookForm={hookFormCadastro}
                            />
                        </span>
                        <span className="ms-1">
                            <DefaultFormCheckBox
                                name='tipoVistoriaConstrutora'
                                label='Construtora'
                                reactHookForm={hookFormCadastro}
                            />
                        </span>
                    </div>
                    <div className="flex flex-row gap-4 w-full justify-between">
                        {
                            !clienteCadastrado ?
                                <div className="w-[70%]">
                                    <DropDownUnidade
                                        name="idCliente"
                                        idCentroCusto={idCentroCusto}
                                        idCliente={null}
                                        label="Cliente"
                                        required={true}
                                        readOnly={saving}
                                        reactHookForm={hookFormCadastro}
                                    />

                                </div>
                                :
                                <div className="w-[70%]">
                                    <DefaultFormInput
                                        name='descCliente'
                                        label="Cliente"
                                        readOnly={false}
                                        required={true}
                                        reactHookForm={hookFormCadastro}
                                    />
                                </div>
                        }

                        <div className="w-[30%] flex items-center">
                            <span className="ms-1 flex items-center">
                                <DefaultFormCheckBox
                                    name='clienteCadastrado'
                                    label='Preencher Cliente'
                                    reactHookForm={hookFormCadastro}
                                />
                            </span>
                        </div>
                    </div>

                    <div className="w-[80%]">
                        <DefaultFormMultiAutocomplete
                            name="idsChecklistEntrega"
                            label="Checklist de Entrega de Obra"
                            required={true}
                            options={ddlChecklistEntregaObra}
                            getOptionLabel={x => x.title}
                            getOptionKey={x => x.id}
                            reactHookForm={hookFormCadastro}
                        />
                    </div>

                    <DefaultFormInput
                        name='localVistoria'
                        label="Local da Vistoria/Ambiente"
                        readOnly={false}
                        required={false}
                        reactHookForm={hookFormCadastro}
                    />
                </>
            </FormContainer>
        </BaseFormControlledModal>
    );
}